export default "/fonts/RV-Harmonia-Bold.eot?8d883a1889ff71adea323351ca15e131";